import { forwardRef, useRef, useImperativeHandle } from 'react';

export default forwardRef(function ValidatedTextInput(
    { 
        type = 'text', 
        className = '', 
        validationState = { status: 'idle', message: '', isValid: true },
        showValidationIcon = true,
        ...props 
    }, 
    ref
) {
    const input = useRef();

    useImperativeHandle(ref, () => ({
        focus: () => input.current?.focus(),
    }));

    // Función para obtener las clases de borde según el estado
    const getBorderClasses = () => {
        const { status, isValid } = validationState;
        
        switch (status) {
            case 'validating':
                return 'border-blue-300 focus:border-blue-500 focus:ring-blue-500';
            case 'valid':
                return 'border-green-300 focus:border-green-500 focus:ring-green-500';
            case 'invalid':
            case 'error':
                return 'border-red-300 focus:border-red-500 focus:ring-red-500';
            default:
                return 'border-gray-300 dark:border-gray-600 focus:border-primary-500 focus:ring-primary-500';
        }
    };

    // Función para obtener el ícono de validación
    const getValidationIcon = () => {
        if (!showValidationIcon) return null;

        const { status } = validationState;
        const baseClasses = "absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5";

        switch (status) {
            case 'validating':
                return (
                    <div className={`${baseClasses} text-blue-500`}>
                        <svg className="animate-spin w-5 h-5" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                        </svg>
                    </div>
                );
                
            case 'valid':
                return (
                    <div className={`${baseClasses} text-green-500`}>
                        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                        </svg>
                    </div>
                );
                
            case 'invalid':
            case 'error':
                return (
                    <div className={`${baseClasses} text-red-500`}>
                        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </div>
                );
                
            default:
                return null;
        }
    };

    return (
        <div className="relative">
            <input
                {...props}
                type={type}
                className={`${className} ${getBorderClasses()} transition-colors pr-10`}
                ref={input}
            />
            {getValidationIcon()}
        </div>
    );
});
